import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { getHttpInstance, getApiConfig } from '@/composables/useApi';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WhatsAppCoachingPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const pressed = ref(false);
        function handleEnableWhatsApp() {
            pressed.value = true;
            const request = {
                title: "welcome_to_mg",
                whatsApp: true,
                whatsAppTemplate: true,
                phoneNumber: state.customer.person.mobilePhone
            };
            getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
                .then(() => { });
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                    class: "pageHeaderIcon",
                    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/640px-WhatsApp.svg.png"
                }, null, -1)),
                (!_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Authenticating . . ."))
                    : _createCommentVNode("", true),
                (_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("p", null, "WhatsApp Coaching", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("p", null, "You can start a WhatsApp chat with one of our Money Coaches. Click the button below to begin.", -1)),
                        _createElementVNode("p", null, [
                            _createVNode(_component_v_btn, {
                                class: "mg-button",
                                disabled: pressed.value,
                                style: { "background-color": "#1dcd45 !important" },
                                onClick: handleEnableWhatsApp
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("Start Coaching Session")
                                ])),
                                _: 1
                            }, 8, ["disabled"])
                        ]),
                        (pressed.value)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                style: { "margin-top": "50px" },
                                text: "Thank you. You will shortly receive a WhatsApp message.",
                                type: "success"
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
